import { attr, fk } from 'redux-orm'
import Base from './Base'

class Template extends Base {
  static get fields() {
    return {
      id: attr(),
      subject: attr(),
      body: attr(),
      kind: attr(),
      officeId: fk({to: 'office', as: 'office', relatedName: 'templates'}),
      scopeId: attr(),
      scopeType: attr()
    }
  }
}

Template.modelName = 'template'

export default Template;
